module.exports = __webpack_public_path__ + "static/media/email_icon.fd7ec62b.svg";